import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";

const IconButtonToggleable = ({ iconOn, iconOff, ...props }) => {
  const [toggled, setToggled] = useState(false);
  return (
    <IconButton onClick={() => setToggled((v) => !v)} {...props}>
      {toggled ? iconOn : iconOff}
    </IconButton>
  );
};

export default IconButtonToggleable;
